import {SortOrder} from "../sort-order";

export class AlarmDefinitionFilters {
  name: string;
  sensors: string[];
  operations: string[];
  sortField: string;
  sortOrder: SortOrder;
}
